<template>
  <div
    class="modal confirmation-modal"
    :class="{ 'is-active': isActive }"
    @keyup.esc="$emit('close-modal')"
  >
    <div class="modal-background"></div>
    <div class="modal-card" v-if="type">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ $t('webhooks.confirmation_modal.title') }}
        </p>
        <button class="delete" aria-label="close" @click="$emit('close-modal')">
          <i class="mdi mdi-close"></i>
        </button>
      </header>
      <section class="modal-card-body">
        <p>
          {{ $t(`webhooks.confirmation_modal.warning.${type}`) }}
        </p>
        <div class="input-container">
          <input
            type="text"
            class="input is-shadowless"
            v-model="text"
            autofocus
            :placeholder="placeholderText"
            @keyup.enter="onConfimration()"
          />
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button cancel-button" @click="$emit('close-modal')">
          {{ $t('webhooks.confirmation_modal.cancel') }}
        </button>
        <button
          class="button confirm-btn"
          @click="onConfimration()"
          :class="{ danger: type === 'delete' }"
          :disabled="text.toUpperCase() !== confirmationText"
        >
          {{ $t('webhooks.confirmation_modal.confirm') }}
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmationModal',
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    confirmationText() {
      return this.type.toUpperCase();
    },

    placeholderText() {
      return `Type ${this.confirmationText}`;
    },
  },

  data() {
    return {
      text: '',
    };
  },

  methods: {
    onConfimration() {
      if (this.text.toUpperCase() !== this.confirmationText) {
        return;
      }

      this.$emit('confirmation-received');
      this.text = '';
    },
  },
};
</script>
<style scoped lang="scss">
.modal-card-foot {
  justify-content: center;

  .cancel-button {
    margin: 0;
  }
}
</style>
